<template>
  <tr>
    <td>{{ trainingDate }}</td>
    <td>{{ measurementType }}</td>
    <template v-if="!isFreeActiveMeasurement">
      <td>{{ hrInZonePercent }}</td>
      <td>{{ averageHeartRate }}</td>
      <td><training-duration :training="training"></training-duration></td>
      <td>{{ distanceStr }}</td>
    </template>
    <td>{{ saturationStr }}</td>
    <td>{{ pressureStr }}</td>
    <template v-if="isFreeActiveMeasurement || isAllActiveMeasurements">
      <td>{{ glucoseStr }}</td>
    </template>
  </tr>
</template>

<script>
import { trainingItem } from '@/mixins/training-item.js'
import { formatDate } from '@/mixins/format-date.js'
import { trainingDate } from '@/mixins/training-date.js'
import { measurementType } from '@/main.config'

import TrainingDuration from '@/components/Training/TrainingDuration.vue'

export default {
  name: 'CourseDataTableRow',
  components: {
    TrainingDuration
  },
  mixins: [trainingItem, trainingDate, formatDate],
  props: {
    training: {
      type: Object,
      required: false
    },
    activeMeasurementType: {
      type: Number,
      required: true
    }
  },
  computed: {
    isFreeMeasurement() {
      return this.training.training_type === undefined
    },
    isFreeActiveMeasurement() {
      return this.activeMeasurementType === measurementType.free
    },
    isAllActiveMeasurements() {
      return this.activeMeasurementType === measurementType.all
    },
    trainingDate() {
      return `${this.getTrainingFormattedStartDate(this.training, true)} ${this.getTrainingStartTime(
        this.training
      )}`
    },
    measurementType() {
      if (this.isFreeMeasurement) {
        return this.$t('entity.freeMeasurementShort')
      } else
        return this.isTrainingStandard ? this.$t('entity.training') : this.$t('src/pages/trainingview.wt6m')
    },
    averageHeartRate() {
      return this.training.rhytmogram_avr_hr
        ? `${this.training.rhytmogram_avr_hr} ${this.$t('unit.bpm')}`
        : '—'
    },
    maxHeartRate() {
      return this.training.rhytmogram_max_hr
        ? `${this.training.rhytmogram_max_hr} ${this.$t('unit.bpm')}`
        : '—'
    },
    saturationStr() {
      if (this.isFreeMeasurement) {
        return this.training.saturation ? `${this.training.saturation}%` : '—'
      }
      if (this.is6MWT) {
        const saturationAfter = this.training.saturation_after
          ? Math.round(this.training.saturation_after) + '%'
          : '—'
        const saturationBefore = this.training.saturation_before
          ? Math.round(this.training.saturation_before) + '%'
          : '—'
        return isNaN(saturationAfter) && isNaN(saturationBefore)
          ? '—'
          : `${saturationBefore} → ${saturationAfter}`
      } else if (this.training.events) {
        const parsedEvent = JSON.parse(this.training.events)
        const saturationEvent = parsedEvent.filter(item => item.episodeType === 'eventSpO2')
        if (saturationEvent.length) {
          let sum = 0
          saturationEvent.forEach(item => (sum += Number(item.value.replace(',', '.'))))
          return `${Math.round(sum / saturationEvent.length)}%`
        } else return '—'
      } else {
        return '—'
      }
    },
    pressureStr() {
      if (this.isFreeMeasurement) {
        return this.training.pressure ? `${this.training.pressure}` : '—'
      }
      if (this.is6MWT) {
        let pressureAfter = this.training.blood_pressure_after || '—'
        let pressureBefore = this.training.blood_pressure_before || '—'
        if (isNaN(pressureAfter) && isNaN(pressureBefore)) {
          return '—'
        } else return `${pressureBefore} → ${pressureAfter}`
      }
      if (this.training.events) {
        let parsedEvent = JSON.parse(this.training.events)
        let pressure = parsedEvent.filter(item => item.episodeType === 'eventBP')
        if (pressure.length) {
          const pressureArray = pressure[0].value.split('/')
          return `${pressureArray[0]} / ${pressureArray[1]}`
        } else return '—'
      } else {
        return '—'
      }
    },
    glucoseStr() {
      return this.training.glucose || '—'
    },
    distanceStr() {
      if (this.is6MWT) {
        if (this.training.distance) return `${this.training.distance} ${this.$t('unit.m')}`
        else return '—'
      } else {
        if (this.training.step_count) return `${this.training.step_count} ${this.$t('unit.steps')}`
        else return '—'
      }
    },
    hrInZonePercent() {
      if (this.training.rhytmogram_zone_percent) {
        return `${this.training.rhytmogram_zone_percent}%`
      } else return '—'
    }
  }
}
</script>
